import gsap from 'gsap';
import { isTouchDevice } from '../utils';

export const Filter = {
  init() {
    const labelEls: NodeListOf<HTMLElement> = document.querySelectorAll('.c-filter .c-filter__label');
    const filterInputEls: NodeListOf<HTMLInputElement> = document.querySelectorAll('.c-filter .c-filter__label input[name="filter"]');
    const cardEls: NodeListOf<HTMLElement> = document.querySelectorAll('[data-filtered-item]');
    const isSubObserver: Record<string, boolean> = {};
    if (labelEls.length && filterInputEls.length && cardEls.length) {
      const filterWrap = document.querySelector('.c-filter') as HTMLElement;
      const initChecked: HTMLInputElement | null = document.querySelector('.c-filter .c-filter__label input[name="filter"]:checked');
      const firstChecked = initChecked ? initChecked : filterInputEls[0];
      changeCurrent(firstChecked, null);
      filterInputEls.forEach((inputEl) => {
        inputEl.addEventListener('change', () => {
          if (inputEl.checked) {
            changeCurrent(inputEl, null);
          }
        });
      });

      labelEls.forEach((labelEl) => {
        const inputEl = labelEl.querySelector('input[name="filter"]') as HTMLInputElement;
        const subfilterEl = document.querySelector<HTMLElement>(`.c-sub-filter[data-parent-filter="${inputEl.value}"]`);
        // inputElのvalueに対応するサブフィルターがある場合
        if (subfilterEl) {
          const closeEl = subfilterEl.querySelector<HTMLElement>('.c-sub-filter__close');
          const subfilterLabeEls = subfilterEl.querySelectorAll('.c-sub-filter__label') as NodeListOf<HTMLElement>;
          subfilterLabeEls.forEach((subfilterLabeEl) => {
            subfilterLabeEl.addEventListener('click', () => {
              inputEl.checked = true;
              const tag = subfilterLabeEl.querySelector('input[name="tag"]:checked') as HTMLInputElement;
              changeCurrent(inputEl, tag.value);
            });
          });
          // サブフィルター閉じるボタン
          if (closeEl) {
            closeEl.addEventListener('click', () => {
              closeSubfilter(labelEl, inputEl);
            });
          }

          // タッチデバイス判定
          if (isTouchDevice()) {
            /// タッチデバイスの場合
            document.body.classList.add('device-touch');
            labelEl.addEventListener('click', () => {
              changeCurrent(inputEl, null);
              toggleSubfilters(labelEls, inputEl);
            });
          } else {
            /// タッチデバイスじゃない場合
            labelEl.addEventListener('click', () => {
              changeCurrent(inputEl, null);
            });
            isSubObserver[inputEl.value] = false;
            labelEl.addEventListener('mouseenter', () => {
              isSubObserver[inputEl.value] = false;
              openSubfilter(labelEl, inputEl);
            });
            labelEl.addEventListener('mouseleave', () => {
              isSubObserver[inputEl.value] = true;
              setTimeout(() => {
                if (isSubObserver[inputEl.value]) {
                  closeSubfilter(labelEl, inputEl);
                }
              }, 200);
            });

            subfilterEl.addEventListener('mouseenter', () => {
              isSubObserver[inputEl.value] = false;
              openSubfilter(labelEl, inputEl);
            });
            subfilterEl.addEventListener('mouseleave', () => {
              isSubObserver[inputEl.value] = true;
              setTimeout(() => {
                if (isSubObserver[inputEl.value]) {
                  closeSubfilter(labelEl, inputEl);
                }
              }, 200);
            });
          }
        }
      });

      // c-filterをスクロールしたときにサブフィルターのPositionを変更
      filterWrap.addEventListener('scroll', () => {
        labelEls.forEach((labelEl) => {
          const inputEl = labelEl.querySelector('input[name="filter"]') as HTMLInputElement;
          const subfilterEl = document.querySelector<HTMLElement>(`.c-sub-filter[data-parent-filter="${inputEl.value}"]`);
          if (!subfilterEl) return;
          setPosition(labelEl, subfilterEl);
        });
      });
    }
  },
  resize() {
    const filter: HTMLElement | null = document.querySelector('.c-filter__list');
    const checked: HTMLInputElement | null = document.querySelector('.c-filter .c-filter__label input[name="filter"]:checked');
    if (filter && checked) {
      const item = checked.parentElement as HTMLElement;
      const filterRect = filter.getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();
      filter.style.setProperty('--width', `${itemRect.width}px`);
      filter.style.setProperty('--left', `${itemRect.left - filterRect.left}px`);
    }
  },
};

const changeCurrent = (inputEl: HTMLInputElement, sub: string | null) => {
  const filter = document.querySelector('.c-filter__list') as HTMLElement;
  const labelEl = inputEl.parentElement as HTMLElement;
  const filterRect = filter.getBoundingClientRect();
  const labelRect = labelEl.getBoundingClientRect();
  filter.style.setProperty('--width', `${labelRect.width.toFixed(2)}px`);
  filter.style.setProperty('--left', `${(labelRect.left - filterRect.left).toFixed(2)}px`);

  const cards: NodeListOf<HTMLElement> = document.querySelectorAll('[data-filtered-item]');
  if (cards.length) {
    cards.forEach((card) => {
      if (card.dataset.filteredItem == inputEl.value || inputEl.value == 'all') {
        if (sub == null) {
          card.classList.remove('hidden');
        } else {
          if (card.getAttribute('data-subfiltered') === sub) {
            card.classList.remove('hidden');
          } else {
            card.classList.add('hidden');
          }
        }
      } else {
        card.classList.add('hidden');
      }
    });
  }
};

const setPosition = (labelEl: HTMLElement, subfilterEl: HTMLElement) => {
  const labelRect = labelEl.getBoundingClientRect();
  const parentEl = subfilterEl.parentElement as HTMLElement;
  const parentRect = parentEl.getBoundingClientRect();
  const left = labelRect.left + labelRect.width * 0.5 - parentRect.left;
  subfilterEl.style.setProperty('--left', `${left.toFixed(2)}px`);
  subfilterEl.style.setProperty('--width', `${(labelRect.width - parentRect.height).toFixed(2)}px`);
};

const toggleSubfilters = (labelEls: NodeListOf<HTMLElement>, inputEl: HTMLInputElement) => {
  labelEls.forEach((labelEl) => {
    const childInputEl = labelEl.querySelector('input[name="filter"]') as HTMLInputElement;
    if (childInputEl.value === inputEl.value) {
      openSubfilter(labelEl, childInputEl);
    } else {
      closeSubfilter(labelEl, childInputEl);
    }
  });
};

const openSubfilter = (labelEl: HTMLElement, inputEl: HTMLInputElement) => {
  const subfilterEl = document.querySelector<HTMLElement>(`.c-sub-filter[data-parent-filter="${inputEl.value}"]`);
  if (!subfilterEl) return;
  setPosition(labelEl, subfilterEl);
  gsap.to(subfilterEl, {
    height: 'auto',
    duration: 0.3,
    onStart: () => {
      labelEl.classList.add('is-hover');
    },
  });
};

const closeSubfilter = (labelEl: HTMLElement, inputEl: HTMLInputElement) => {
  const subfilterEl = document.querySelector<HTMLElement>(`.c-sub-filter[data-parent-filter="${inputEl.value}"]`);
  if (!subfilterEl) return;
  gsap.to(subfilterEl, {
    height: 0,
    duration: 0.3,
    onStart: () => {
      labelEl.classList.remove('is-hover');
    },
  });
};
